<div class="sub-header">
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="col">
        <div class="float-end fs-4 text-primary">
          {{ this.periodLabel }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        @if (!!this.activeSalesTeams) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 200px;"
              bindValue="id"
              bindLabel="name"
              [items]="activeSalesTeams"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="salesTeamIds"
              (ngModelChange)="onSalesTeamIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }}
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length}">COMPANY_COMMISSION_LBL_SALESTEAM_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/>
                <span class="ps-1">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        }
        @if (this.activeSalesTeamMembers) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 250px;"
              bindValue="userId"
              bindLabel="userContactName"
              [items]="activeSalesTeamMembers"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="salesTeamMemberUserIds"
              (ngModelChange)="onSalesTeamMembersIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].userContactName }}
                }
                @if (items.length > 1) {
                  <span translate
                  [translateParams]="{ p1: items.length}">COMPANY_COMMISSION_LBL_SALESTEAMMEMBER_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/><span
              class="ps-1">{{ item.userContactName }}</span>
            </ng-template>
          </ng-select>
        </div>
      }
    </div>
    <div class="col">
      @if (this.periods$ | async; as periods) {
        <div
          class="d-inline-block float-end fs-4"
          >
          <select
            class="form-control form-control-sm form-select"
            [ngModel]="this.defaultPeriod"
            (change)="onPeriodChange($event)"
            >
            <option disabled style="background-color: lightgray" translate>
              DASHBOARD_LBL_SELECT_OPTION_GROUP_STANDARD_PERIOD
            </option>
            @for (period of periods; track period) {
              @if (period.group == 'Périodes standards') {
                <option
                  value="{{ period.value }}"
                  >
                  {{ period.label }}
                </option>
              }
            }
            <option disabled style="background-color: lightgray" translate>
              DASHBOARD_LBL_SELECT_OPTION_GROUP_RECENTLY
            </option>
            @for (period of periods; track period) {
              @if (period.group == 'Récemment') {
                <option
                  value="{{ period.value }}"
                  >
                  {{ period.label }}
                </option>
              }
            }
          </select>
        </div>
      }
    </div>
  </div>
</div>
</div>
